import { render, staticRenderFns } from "./medicationDetail.vue?vue&type=template&id=53657ea5&scoped=true&"
import script from "./medicationDetail.vue?vue&type=script&lang=js&"
export * from "./medicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./medicationDetail.vue?vue&type=style&index=0&id=53657ea5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53657ea5",
  null
  
)

export default component.exports